module.exports = __webpack_public_path__ + "static/media/h5_future.700f215a.png";